import { inject, Injectable } from '@angular/core';
import { DocConverterApiService } from '@core/generic-api/data-access';
import { PDF_GENERATOR_CONFIG, PDF_PRINT_OPTIONS_MARGIN } from '../constant';
import { HttpClient } from '@angular/common/http';
import { render } from 'ejs';
import { combineLatest, concatMap, Observable, of } from 'rxjs';
import { GeneratePdfFileArgs } from '../type';

@Injectable({ providedIn: 'root' })
export class PdfGeneratorService {
  private readonly converterApiService = inject(DocConverterApiService);
  private readonly config = inject(PDF_GENERATOR_CONFIG);
  private readonly http = inject(HttpClient);

  render(html: string, data: any): string {
    try {
      return render(html, data);
    } catch (error) {
      console.error(error);
      return '';
    }
  }

  generatePdfFile(args: GeneratePdfFileArgs): Observable<Blob> {
    const request = [
      args.header ? of(args.header) : this.http.get(this.config.headerPath, { responseType: 'text' }),
      args.footer ? of(args.footer) : this.http.get(this.config.footerPath, { responseType: 'text' }),
    ];

    return combineLatest(request).pipe(
      concatMap(([header, footer]) =>
        this.converterApiService.html2pdf({
          html: args.html,
          printOptions: {
            headerTemplate: header,
            footerTemplate: footer,
            displayHeaderFooter: args.displayHeaderFooter,
            margin: PDF_PRINT_OPTIONS_MARGIN,
          },
        })
      )
    );
  }
}
